import {
  Autocomplete,
  FormControl,
  Grid,
  TextField,
  TextFielDecimalNumbers,
} from "../../../../../../components";

const ImpostoProdutoIbsTab = ({
  nfSaidaId,
  produtoEditado,
  situacaoIbsList,
  classificacaoIbsList,
}) => {
  
  // const handleChangeClassificacaoIbs = (value) => {
  //   setProdutoEditado({
  //     ...produtoEditado,
  //     tributosClassificacaoIbs: value?.codigoClassificacao,
  //   });
  // }

  // const handleChangeSituacaoIbs = (e, value) => {
  //   handleChangeClassificacaoIbs(null);
  //   if (value) {
  //     buscaClassificacoesIbs(value.codigo);
  //   } else {
  //     setClassificacaoIbsList([]);
  //   }
  //   onChangeAutocompleteCodigo("tributosIbsCst", value);
  // }

  return (
    <>
      <Grid container spacing={2} className="mt-1">
        <Grid item xs={4}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="situacaoIbsId"
              name="situacaoIbsId"
              options={situacaoIbsList}
              disabled={!!nfSaidaId}
              autoHighlight
              getOptionLabel={(option) =>
                option ? `${option?.codigo} - ${option?.descricao}` : ""
              }
              getOptionSelected={(option, value) =>
                option?.descricao === value?.descricao
              }
              noOptionsText="Sem opções"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Situação Tributária IBS/CBS"
                  variant="outlined"
                  margin="normal"
                />
              )}
              value={
                situacaoIbsList?.length &&
                situacaoIbsList.find(
                  (objeto) => objeto?.codigo == produtoEditado.tributosIbsCst
                )
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={8}>
          <FormControl variant="outlined" fullWidth>
            <Autocomplete
              id="classificacaoIbsId"
              name="classificacaoIbsId"
              disabled={!!nfSaidaId}
              options={classificacaoIbsList}
              autoHighlight
              getOptionLabel={(option) =>
                option ? `${option?.codigoClassificacao} - ${option?.nomeClassificacao}` : ""
              }
              getOptionSelected={(option, value) =>
                option?.descricao === value?.descricao
              }
              noOptionsText="Sem opções"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Classificação IBS/CBS"
                  variant="outlined"
                  margin="normal"
                />
              )}
              value={
                classificacaoIbsList?.length &&
                classificacaoIbsList.find(
                  (objeto) => objeto?.codigoClassificacao == produtoEditado.tributosIbsClassificacao
                )
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsUf"
            name="aliquotaIbsUf"
            label="Alíquota IBS UF"
            margin="normal"
            variant="outlined"
            fullWidth
            disabled={!!nfSaidaId}
            value={produtoEditado?.tributosIbsAliquotaUf ?? ""}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsMun"
            name="aliquotaIbsMun"
            label="Alíquota IBS Municipal"
            margin="normal"
            variant="outlined"
            fullWidth
            disabled={!!nfSaidaId}
            value={produtoEditado?.tributosIbsAliquotaMun ?? ""}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsCbs"
            name="aliquotaIbsCbs"
            label="Alíquota CBS"
            margin="normal"
            variant="outlined"
            fullWidth
            disabled={!!nfSaidaId}
            value={produtoEditado?.tributosIbsAliquotaCbs ?? ""}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsRedUf"
            name="aliquotaIbsRedUf"
            label="Alíquota IBS UF Red."
            margin="normal"
            variant="outlined"
            fullWidth
            disabled={!!nfSaidaId}
            value={produtoEditado?.tributosIbsAliquotaRedUf ?? ""}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsRedMun"
            name="aliquotaIbsRedMun"
            label="Alíquota IBS Municipal Red."
            margin="normal"
            variant="outlined"
            fullWidth
            disabled={!!nfSaidaId}
            value={produtoEditado?.tributosIbsAliquotaRedMun ?? ""}
          />
        </Grid>
        <Grid item xs={4}>
          <TextFielDecimalNumbers
            id="aliquotaIbsRedCbs"
            name="aliquotaIbsRedCbs"
            label="Alíquota CBS Red."
            margin="normal"
            variant="outlined"
            fullWidth
            disabled={!!nfSaidaId}
            value={produtoEditado?.tributosIbsAliquotaRedCbs ?? ""}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ImpostoProdutoIbsTab;
